import { rankMixin } from "@mixin/rank";
export default {
  name: "pageRank",
  mixins: [rankMixin],
  methods: {}
};